import React, { useState, useEffect, useRef } from 'react';
import {
    Btn,
    Container,
    Box,
    PanelKeys,
} from '@saladbob/sassafras'

import toast from 'react-hot-toast';

import { CreateUserAccount } from './forms/UserAccount';
import UserContact from './forms/UserContact';
import UserProfile from './forms/UserProfile';
import UserVanity from './forms/UserVanity';
import BackBtn from './buttons/BackBtn';

import saveUser from '../crud/saveUser';
import login from '../crud/login';
import { fetchUser } from '../hooks/useSwr';

import { User } from '../types';

type Props = {
    onCreate?: Function,
};

const CreateAccount: React.FC<Props> = ({ onCreate }) => {
    const {mutate} = fetchUser();
    const [step, setStep] = useState('account');
    const isSubmitting = useRef(false);
    const [disabled, setDisabled] = useState(false);
    const [tempUser, setTempUser] = useState<User>({});

    useEffect(() => {
        setDisabled(isSubmitting.current);
    }, [isSubmitting]);

    const toProfile = (form, data) => {
        setTempUser({ ...tempUser, ...data});
        setStep('profile');
    };

    const toContact = (form, data) => {
        setTempUser({ ...tempUser, ...data});
        setStep('contact');
    };

    const toVanity = (form, data) => {
        setTempUser({ ...tempUser, ...data});
        setStep('vanity');
    };

    const setUser = (data) => {
        setTempUser({ ...tempUser, ...data});
    };

    const onSubmit = async (form, data) => {
        if (isSubmitting.current) {
            return;
        };

        const newData = { ...tempUser, ...data };
        const imageUpload = newData.imageUpload;
    
        delete newData.imageUpload;

        setTempUser(newData);

        const res: Promise<User> = new Promise(async (resolve, reject) => {
            isSubmitting.current = true;
            const r = await saveUser(newData);

            if (r.errors) {
                mutate(null);
                reject(r);
            } else {
                const { user: { id }} = await login({ email: newData.email, password: newData.password });
                const u = await saveUser({ id, canEdit: true, imageUpload });

                if (u.errors) {
                    console.log(u.errors);
                    reject(u.errors);
                };
                resolve(u.doc);
            }
        });
        toast.promise(res, {
            loading: 'Creating Your Account..',
            success: (r) => {
                onCreate(r);
                isSubmitting.current = false;
                return 'Logged in!';
            },
            error: (err) => {
                setStep('account');
                isSubmitting.current = false;
                return err.message;
            },
        });
    };

    return (
        <Container maxWidth="640px">
            <PanelKeys step={step} travel={0}>
                <CreateUserAccount
                    key="account"
                    user={tempUser}
                    onSubmit={toProfile}
                >
                    <div>
                        <Btn mt="lg" padding={[0, 'xxl']} mb="lg" full size="lg">
                            Next
                        </Btn>
                    </div>
                </CreateUserAccount>
                <UserProfile
                    key="profile"
                    showGender
                    user={tempUser}
                    onSubmit={toContact}
                >
                    <div>
                        <Btn mt="lg" padding={[0, 'xxl']} mb="lg" full size="lg">
                            Next
                        </Btn>
                    </div>
                    <BackBtn onClick={() => setStep('account')}/>
                </UserProfile>
                <UserContact
                    key="contact"
                    user={tempUser}
                    onSubmit={toVanity}
                >
                    <div>
                        <Btn mt="lg" padding={[0, 'xxl']} mb="lg" color={ disabled ? 'neutral' : 'primary'} full size="lg">
                            Continue
                        </Btn>
                    </div>
                    <BackBtn onClick={() => setStep('profile')} />
                </UserContact>
                <UserVanity
                    key="vanity"
                    user={tempUser}
                    setUser={setUser}
                    onSubmit={onSubmit}
                >
                    <div>
                        <Btn mt="lg" padding={[0, 'xxl']} mb="lg" color={ disabled ? 'neutral' : 'primary'} full size="lg">
                            Create Account
                        </Btn>
                    </div>
                    <BackBtn onClick={() => setStep('contact')} />
                </UserVanity>
            </PanelKeys>
        </Container>
    );
}

CreateAccount.defaultProps = {
    onCreate: () => {},
};

export default CreateAccount;